import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cs from './i18n/cs.json';
import en from './i18n/en.json';
import { languageStorage } from './utils/languageStorage';

// Get stored language or default to English (per FR-001 in i18n spec)
const storedLanguage = languageStorage.get() || 'en';

i18n.use(initReactI18next).init({
  resources: {
    cs: { translation: cs },
    en: { translation: en },
  },
  lng: storedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
